/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meta_Compare_TitleInputs */

const en_meta_compare_title = /** @type {(inputs: Meta_Compare_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Why students and researchers choose Listening | Listening`)
};

const es_meta_compare_title = /** @type {(inputs: Meta_Compare_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por qué estudiantes e investigadores eligen Listening | Listening`)
};

/**
* | output |
* | --- |
* | "Why students and researchers choose Listening \| Listening" |
*
* @param {Meta_Compare_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const meta_compare_title = /** @type {((inputs?: Meta_Compare_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meta_Compare_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_meta_compare_title(inputs)
	return en_meta_compare_title(inputs)
});